// extracted by mini-css-extract-plugin
export default {"prefooter":"Prefooter_prefooter__x7pZn","phone":"Prefooter_phone__YdxcO","prefooterOption":"Prefooter_prefooterOption__a2o8A","title":"Prefooter_title__ApIIj"};